import * as z from 'zod';
import { StoreRegion } from '~/graphql/graphql.gen';

export const calendarQueryParamsSchema = z.object({
  category: z.string().array().catch([]),
  csm: z.string().array().catch([]),
  date: z.string().optional(),
  division: z.string().array().catch([]),
  id: z.string().optional(),
  operationType: z.string().array().catch([]),
  plugin: z.string().array().catch([]),
  region: z.enum([StoreRegion.Fr, StoreRegion.Us]).catch(StoreRegion.Fr),
  sales: z.string().array().catch([]),
  setup: z.string().array().catch([]),
  tiering: z.string().array().catch([]),
  topBrandType: z.string().array().catch([]),
  type: z.string().array().catch([]),
});

export type CalendarQueryParams = z.infer<typeof calendarQueryParamsSchema>;
